
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns71ce1d6f08f0a7deaefb5e833239bea3en from './en.yaml'
            i18n.addResourceBundle('en', '71ce1d6f08f0a7deaefb5e833239bea3', flattenObject(ns71ce1d6f08f0a7deaefb5e833239bea3en), true, true);
        
        export default '71ce1d6f08f0a7deaefb5e833239bea3';
    